

































































import { Component, Mixins } from 'vue-property-decorator';
import BlogCard from '@rogues/BlogCard/shared/blogCard';

@Component
/**
 * @name Multimedia
 */
export default class Multimedia extends Mixins(BlogCard) {
    responsive = {
        chips: {
            768: 'xsmall',
        },
    }
}
